import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Nav from "../../Components/Navbar/NewNavbar"
import Loading1 from '../../Components/Loading/Loading1';
import { HiOutlineDocumentText, HiOutlineScale, HiOutlineMail, HiOutlinePhone } from 'react-icons/hi';

const TermConditions = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);
        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    const termSections = [
        {
            id: "1",
            title: "Introduction",
            content: "Welcome to Astra Clean. These terms and conditions outline the rules and regulations for the use of Astra Clean's website and services. By accessing this website, we assume you accept these terms and conditions in full."
        },
        {
            id: "2",
            title: "Services",
            content: "Astra Clean provides premium home and professional cleaning services, including but not limited to residential cleaning, commercial cleaning, and specialized hygiene solutions."
        },
        {
            id: "3",
            title: "Booking and Payment",
            content: "All services must be booked through our official digital channels. Payments are required at the time of booking or via COD for select services. We accept major credit/debit cards, UPI, and bank transfers."
        },
        {
            id: "4",
            title: "Cancellation & Rescheduling",
            content: "Due to our immediate 2-hour service response time, we do not support cancellations. However, we offer full flexibility for rescheduling your appointment to a more convenient date and time."
        }
    ];

    return (
        <div className="bg-white min-h-screen">
            <Nav />
            
            <section className="pt-40 pb-20 bg-secondary relative overflow-hidden">
                <div className="container-custom relative z-10">
                    <div className="max-w-3xl">
                        <span className="text-primary font-black uppercase tracking-[0.3em] text-xs">Legal Framework</span>
                        <h1 className="text-5xl md:text-6xl font-heading font-black text-foreground mt-4">
                            Terms & <span className="text-primary italic">Conditions</span>
                        </h1>
                        <p className="text-muted-foreground text-lg mt-6 leading-relaxed">
                            Please review our operational guidelines. These terms ensure a safe and professional environment for both our clients and cleaning specialists.
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-24">
                <div className="container-custom">
                    <div className="grid lg:grid-cols-12 gap-16">
                        {/* Summary Card */}
                        <div className="lg:col-span-4 lg:sticky lg:top-32 h-fit space-y-6">
                            <div className="p-8 rounded-[2rem] bg-secondary/50 border border-border">
                                <h4 className="font-heading font-black text-xs uppercase tracking-widest text-primary mb-6 flex items-center gap-2">
                                    <HiOutlineScale size={18} />
                                    Accountability
                                </h4>
                                <ul className="space-y-4">
                                    {["Service Standards", "Payment Security", "Client Responsibility", "Liability Policy"].map((item, i) => (
                                        <li key={i} className="text-sm font-bold text-muted-foreground flex items-center gap-3">
                                            <div className="w-1.5 h-1.5 rounded-full bg-primary/40"></div>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Terms Content */}
                        <div className="lg:col-span-8 space-y-12">
                            {termSections.map((section) => (
                                <div key={section.id} className="space-y-4">
                                    <div className="flex items-center gap-4">
                                        <span className="text-xs font-black text-primary bg-primary/10 w-8 h-8 rounded-lg flex items-center justify-center">
                                            {section.id.padStart(2, '0')}
                                        </span>
                                        <h2 className="text-2xl font-black text-foreground">{section.title}</h2>
                                    </div>
                                    <p className="text-foreground/70 leading-relaxed pl-12">
                                        {section.content}
                                    </p>
                                </div>
                            ))}

                            {/* Additional Sections simplified for brevity in this UI view */}
                            <div className="p-10 rounded-[2.5rem] bg-primary/5 border border-primary/10 mt-20 space-y-6">
                                <h3 className="text-xl font-black">Need Legal Clarification?</h3>
                                <p className="text-sm text-foreground/60 leading-relaxed font-medium">
                                    Our legal team is available to discuss any specific clauses or custom service agreements you may require.
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <Link to="mailto:lakshjain1218@outlook.com" className="flex items-center gap-2 px-6 py-3 rounded-xl bg-white text-xs font-black uppercase tracking-widest shadow-sm hover:shadow-md transition-all">
                                        <HiOutlineMail size={16} />
                                        Email Legal
                                    </Link>
                                    <Link to="tel:+916366267882" className="flex items-center gap-2 px-6 py-3 rounded-xl bg-white text-xs font-black uppercase tracking-widest shadow-sm hover:shadow-md transition-all">
                                        <HiOutlinePhone size={16} />
                                        Call Helpline
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default TermConditions;